module.exports = __webpack_public_path__ + "static/story5-hero-1920x1080-d91db37652aab5adf46ee7b5fe65197b.jpg";